<template>
  <WsAccount
    :modelName="modelName"
    :localeMode="localeMode"
    :label="label"
    :fields="fields"
    :primary="pageSetting.primary"
    titleKey="name"
    :isMultiSelect="true"
    :showExpand="false"
    id="user"
    :avatarHideFields="avatarHideFields"
    :accountHideFields="accountHideFields"
    :passwordHideFields="passwordHideFields"
    :getDefaultImg="getDefaultImg"
  >
  </WsAccount>
</template>

<script>
import model from "@/models/account_setting";
export default {
  data: () => ({
    modelName: model.modelName,
    label: model.label,
    localeMode: true,
    fields: model.fields,
    getDefaultImg: true,
    avatarHideFields: [
      // "id",
      "email",
      "password",
      "new_password",
      "new_password_confirmation",
      "fake_password",
      "name",
      "is_active",
      "organizations",
      "factories",
      "sequence",
    ],
    accountHideFields: [
      // "id",
      // "email",
      "password",
      "new_password",
      "new_password_confirmation",
      "fake_password",
      // "name",
      "is_active",
      "avatar",
      "organizations",
      "factories",
      "sequence",
    ],
    passwordHideFields: [
      // "id",
      "email",
      // "password",
      // "new_password",
      // "new_password_confirmation",
      "fake_password",
      "name",
      "is_active",
      "avatar",
      "organizations",
      "factories",
      "sequence",
    ],
    showFields: ["id", "email"],
    pageSetting: {
      primary: [
        {
          type: "infoCard",
          floors: [
            {
              title: "角色資訊",
              fields: ["avatar", "name", "email", "fake_password"],
            },
          ],
        },
      ],
    },
  }),
};
</script>